import { Link } from 'react-router-dom';

export default function CoursesSection() {
  const courses = [
    {
      name: '数学強化コース',
      description: '基本から応用まで、高校入試に対応できる力を身に付けます',
      price: '月額1コマ 8,000円',
      features: ['入試対策', 'ポイント解説', '単元別教材', '質の高い授業'],
      image: 'https://static.readdy.ai/image/58c223b9eef17a4b88bac47f4e33252a/da10e06bfba82bacdb88594d087b0bb9.jpeg',
      highlight: false
    },
    {
      name: 'スタディコース',
      description: '少人数個別指導により、分からないところを徹底理解',
      price: '月額1コマ 8,000円',
      features: ['少人数指導', '全教科対応', '進路相談', '第1志望校対策'],
      image: 'https://static.readdy.ai/image/58c223b9eef17a4b88bac47f4e33252a/6225996758aeec267422d5742c920c8b.jpeg',
      highlight: false
    },
    {
      name: 'サポートコース',
      description: '自学自習スタイルで取り組むコース',
      price: '1回 500円',
      features: ['質問対応', '自習サポート', '宿題フォロー', '学習習慣定着'],
      image: 'https://static.readdy.ai/image/58c223b9eef17a4b88bac47f4e33252a/6e13a3d80ada2eef8294b839b6e2dafb.jpeg',
      highlight: false
    },
    {
      name: '完全個別指導コース',
      description: 'マンツーマン指導で、徹底的に理解を深めます',
      price: '1回 6,000円',
      features: ['マンツーマン', '予約制', '苦手克服', 'オンライン可'],
      image: 'https://static.readdy.ai/image/58c223b9eef17a4b88bac47f4e33252a/1cb7cfca047af27e1f9c6a22744e553c.jpeg',
      highlight: false
    }
  ];

  return (
    <section className="py-24 bg-[#1a2332]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            選べる学習スタイル
          </h2>
          <p className="text-white/80 text-lg">
            一人ひとりに合わせた指導方法で、確実な成績アップを実現
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {courses.map((course, index) => (
            <div
              key={index}
              className={`rounded-3xl overflow-hidden transition-all duration-300 hover:-translate-y-2 ${
                course.highlight ? 'bg-[#4a90e2] shadow-2xl' : 'bg-[#2a3442]'
              }`}
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={course.image}
                  alt={course.name}
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="p-6">
                <h3 className="text-xl font-bold text-white mb-3">
                  {course.name}
                </h3>
                <p className="text-white/80 mb-4 leading-relaxed text-sm">
                  {course.description}
                </p>

                <div className="mb-4">
                  <p className="text-2xl font-bold text-white mb-1">
                    {course.price}
                  </p>
                  <p className="text-white/60 text-xs">※税込価格</p>
                </div>

                <ul className="space-y-2 mb-6">
                  {course.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center gap-2 text-white/90">
                      <i className="ri-check-line text-lg"></i>
                      <span className="text-xs">{feature}</span>
                    </li>
                  ))}
                </ul>

                <Link
                  to="/course"
                  className={`block w-full text-center py-3 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer text-sm ${
                    course.highlight
                      ? 'bg-white text-[#4a90e2] hover:bg-gray-100'
                      : 'border-2 border-white text-white hover:bg-white hover:text-[#1a2332]'
                  }`}
                >
                  詳細を見る
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/trial#trial-form-section"
            className="inline-flex items-center gap-3 bg-white text-[#1a2332] px-10 py-5 rounded-full text-lg font-semibold hover:bg-gray-100 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            無料体験に申し込む
            <i className="ri-arrow-right-line text-xl"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
